import React from 'react';
import useAuth from 'state/auth/hooks/useAuth';

/**
 * Conditionally renders a wrapped component based on the `isNativeMode` flag from useAuth.
 * In native mode of app these components will be hidden
 *
 * @param {React.ComponentType} Component - The React component to be conditionally rendered.
 * @returns {React.FC} A functional component that renders the given component
 *                     if the `isNativeMode` flag is false; otherwise, returns null.
 */
const hideInNativeMode = (Component: React.ComponentType) => {
  const WrappedComponent: React.FC = () => {
    const { auth } = useAuth();
    const { isNativeMode } = auth;

    if (!isNativeMode) {
      return <Component />;
    }
    return null;
  };

  return WrappedComponent;
};

export default hideInNativeMode;
